import React from "react";
import PropTypes from "prop-types";
import TreeSelectMultiModalWithSearch from "./TreeSelectMultiModalWithSearch";

function ReduxFormDecorator({ input, meta, ...rest }) {
    return (
        <TreeSelectMultiModalWithSearch
            selectedOptions={input.value || undefined}
            onChange={input.onChange}
            error={meta.touched ? meta.error || meta.warning : undefined}
            onFocus={input.onFocus}
            onBlur={input.onBlur}
            {...rest}
        />
    );
}

ReduxFormDecorator.propTypes = {
    input: PropTypes.object,
    meta: PropTypes.object,
};

export default ReduxFormDecorator;
